import { gql } from "apollo-boost";

export const CREATE_OR_UPDATE_TAX_VOUCHER_SEQUENCES = gql`
  mutation createOrUpdateTaxVoucherSequences($data: TaxVoucherSequencesInput!) {
    createOrUpdateTaxVoucherSequences(data: $data)
  }
`;

export const GET_TYPE_TAX_VOUCHERS_SEQUENCES = gql`
  query getTypeTaxVoucherSequences(
    $where: TaxVoucherSequencesInput
    $relations: [String]
  ) {
    getTypeTaxVoucherSequences(where: $where, relations: $relations) {
      id
      typeTaxVoucherId
      pharmacyProviderId
      available
      last
      lastSeq
      endSeq
      sequenceAlert
      frequencySeqAlert
      enabled
      expirationDate
      taxVoucherSequencesHistory {
        id
        pharmacyProviderId
        startSeq
        lastSeq
        expirationDate
      }
    }
  }
`;

export const GET_CONSULTORY_ISSUED_TAX_VOUCHERS = gql`
  query getConsultoryIssuedTaxVouchers(
    $pharmacyProviderId: Int!
    $typeTaxVoucherId: Int!
  ) {
    getConsultoryIssuedTaxVouchers(
      pharmacyProviderId: $pharmacyProviderId
      typeTaxVoucherId: $typeTaxVoucherId
    ) {
      name
      date
      receiver
      rnc
      amount
      expirationDate
    }
  }
`;

export const GET_CONSULTORY_EXPIRED_UNUSED_TAX_VOUCHERS = gql`
  query getConsultoryExpiredUnusedTaxVouchers(
    $pharmacyProviderId: Int!
    $typeTaxVoucherId: Int!
  ) {
    getConsultoryExpiredUnusedTaxVouchers(
      pharmacyProviderId: $pharmacyProviderId
      typeTaxVoucherId: $typeTaxVoucherId
    ) {
      name
      date
      receiver
      rnc
      amount
      expirationDate
    }
  }
`;
